import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import queryString from 'query-string';

import { useTheme } from '../../ThemeContext';

import Helmet from '../../components/Helmet';
import ResetPasswordPanel from '../../components/ResetPasswordPanel';
import LoadingData from '../../components/LoadingData';

import { Section, Wrapper, Content, Footer } from './AuthPage.style';

const AuthPage = ({ location, history }) => {
  const intl = useIntl();
  const theme = useTheme();
  const [oobCode, setOobCode] = useState(undefined);
  const [mode, setMode] = useState(undefined);

  useEffect(() => {
    const params = queryString.parse(location.search);
    if (
      Object.keys(params).length > 0 &&
      params.oobCode &&
      params.mode &&
      params.mode === 'resetPassword'
    ) {
      setOobCode(params.oobCode);
      setMode(params.mode);
    } else history.push('/forgot-password');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet
        title={intl.formatMessage({
          id: mode
            ? `PAGE_TITLE.${mode === 'resetPassword' ? 'RESET_PASSWORD' : ''}`
            : `PAGE_TITLE.PLEASE_WAIT`,
        })}
      />
      <Section>
        <Wrapper theme={theme.sign.wrapper.default}>
          <Content>
            {mode === 'resetPassword' ? (
              <ResetPasswordPanel oobCode={oobCode} />
            ) : (
              <LoadingData />
            )}
          </Content>
          <Footer theme={theme.sign.footer.default}>
            By signing in, you accept{' '}
            <a
              href='http://www.bine.world'
              target='_blank'
              rel='noopener noreferrer'
            >
              Privacy policy
            </a>{' '}
            <br />
            (including Use of Cookies and Other
            <br /> Technologies) and{' '}
            <a
              href='http://www.bine.world'
              target='_blank'
              rel='noopener noreferrer'
            >
              Terms of use
            </a>
          </Footer>
        </Wrapper>
      </Section>
    </>
  );
};

export default AuthPage;
